import type { Drawable } from '../../types';

export class Cloud implements Drawable {
  x: number;
  y: number;
  readonly width = 46;
  readonly height = 14;
  private readonly speedMultiplier: number;

  constructor(canvasWidth: number) {
    this.x = canvasWidth;
    this.y = 30 + Math.random() * 320;
    this.speedMultiplier = 0.25 + Math.random() * 0.35;
  }

  update(gameSpeed: number): void {
    this.x -= gameSpeed * this.speedMultiplier;
  }

  isOffscreen(): boolean {
    return this.x + this.width < 0;
  }

  draw(ctx: CanvasRenderingContext2D): void {
    ctx.fillStyle = '#c4c4c4';
    const { x, y } = this;
    ctx.fillRect(x + 8, y, 26, 4);
    ctx.fillRect(x, y + 4, 46, 6);
    ctx.fillRect(x + 12, y + 10, 22, 4);
  }
}
